import { forwardRef, type Ref, type SVGProps } from "react";

function SvgEmailFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10" {...props}>
      <path
        fill="currentColor"
        d="M.066 1.778 5.393 4.57c.382.2.832.2 1.214 0l5.327-2.792C11.691.757 10.805 0 9.75 0h-7.5C1.195 0 .309.757.066 1.778"
      />
      <path
        fill="currentColor"
        d="M12 2.793 7.011 5.408a2.17 2.17 0 0 1-2.022 0L0 2.793v4.863C0 8.951 1.007 10 2.25 10h7.5C10.993 10 12 8.95 12 7.656z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgEmailFilled);
export default ForwardRef;
